export default __webpack_public_path__ + "static/media/NoImage.4843c7dc.svg";